/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevertBedSwapEligibilityResponse
 */
export interface RevertBedSwapEligibilityResponse {
    /**
     * Whether the bed swap can be reverted
     * @type {boolean}
     * @memberof RevertBedSwapEligibilityResponse
     */
    can_revert?: boolean;
    /**
     * Date when the bed swap occurred (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    swap_date?: string;
    /**
     * ID of the other lead involved in the swap (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    swapped_with_lead_id?: string;
    /**
     * Name of the other lead involved in the swap (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    swapped_with_lead_name?: string;
    /**
     * Name of the current bed (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    current_bed_name?: string;
    /**
     * Name of the original bed before swap (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    original_bed_name?: string;
    /**
     * Name of the other resident's current bed (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    other_resident_current_bed_name?: string;
    /**
     * Name of the other resident's original bed (present when can_revert is true)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    other_resident_original_bed_name?: string;
    /**
     * Reason why the swap cannot be reverted (present when can_revert is false)
     * @type {string}
     * @memberof RevertBedSwapEligibilityResponse
     */
    reason?: string;
}

/**
 * Check if a given object implements the RevertBedSwapEligibilityResponse interface.
 */
export function instanceOfRevertBedSwapEligibilityResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RevertBedSwapEligibilityResponseFromJSON(json: any): RevertBedSwapEligibilityResponse {
    return RevertBedSwapEligibilityResponseFromJSONTyped(json, false);
}

export function RevertBedSwapEligibilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevertBedSwapEligibilityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'can_revert': !exists(json, 'can_revert') ? undefined : json['can_revert'],
        'swap_date': !exists(json, 'swap_date') ? undefined : json['swap_date'],
        'swapped_with_lead_id': !exists(json, 'swapped_with_lead_id') ? undefined : json['swapped_with_lead_id'],
        'swapped_with_lead_name': !exists(json, 'swapped_with_lead_name') ? undefined : json['swapped_with_lead_name'],
        'current_bed_name': !exists(json, 'current_bed_name') ? undefined : json['current_bed_name'],
        'original_bed_name': !exists(json, 'original_bed_name') ? undefined : json['original_bed_name'],
        'other_resident_current_bed_name': !exists(json, 'other_resident_current_bed_name') ? undefined : json['other_resident_current_bed_name'],
        'other_resident_original_bed_name': !exists(json, 'other_resident_original_bed_name') ? undefined : json['other_resident_original_bed_name'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
    };
}

export function RevertBedSwapEligibilityResponseToJSON(value?: RevertBedSwapEligibilityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'can_revert': value.can_revert,
        'swap_date': value.swap_date,
        'swapped_with_lead_id': value.swapped_with_lead_id,
        'swapped_with_lead_name': value.swapped_with_lead_name,
        'current_bed_name': value.current_bed_name,
        'original_bed_name': value.original_bed_name,
        'other_resident_current_bed_name': value.other_resident_current_bed_name,
        'other_resident_original_bed_name': value.other_resident_original_bed_name,
        'reason': value.reason,
    };
}

